import {
  ResetPasswordRequestOtpBodyType,
  ResetPasswordRequestOtpResponseType
} from "@website/widget/login/services/reset-password-request-otp/reset-password-request-otp.types";
import { BASE_URL_PROFILE } from "@website/widget/login/services/urls";
import { Axios } from "@website/widget/login/utils";
import { AxiosResponse } from "axios";

export const ResetpasswordRequestOtpUrl = `${BASE_URL_PROFILE}/reset-password/request-otp`;

export const ResetPasswordRequestOtpService = (
  body: ResetPasswordRequestOtpBodyType
): Promise<ResetPasswordRequestOtpResponseType> =>
  Axios.post(ResetpasswordRequestOtpUrl, body).then(
    ({ data }: AxiosResponse<ResetPasswordRequestOtpResponseType>) => data
  );
